import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./TestResultsPage.css";
import FakeNavigation from "../../../components/FakeNav/FakeNav";
import search from "../../../assets/search.png";

const MOSCOW_TIME_ZONE = "Europe/Moscow";

const formatCourseDate = (value?: string | null) => {
  const date = value ? new Date(value) : new Date();
  return Number.isNaN(date.getTime())
    ? new Date().toLocaleDateString("ru-RU", { timeZone: MOSCOW_TIME_ZONE })
    : date.toLocaleDateString("ru-RU", { timeZone: MOSCOW_TIME_ZONE });
};

const TestResultsPage: React.FC = () => {
  const navigate = useNavigate();
  const [attempts, setAttempts] = useState<any[]>([]);

  // Получаем попытки из localStorage
  useEffect(() => {
    const savedAttempts = JSON.parse(localStorage.getItem("attempts") || "[]");
    setAttempts(savedAttempts);
  }, []);

  // Отправляем последнюю попытку на сервер


  const handlePrint = () => {
    const lastAttempt = attempts[attempts.length - 1];
    const attemptId = lastAttempt?.attemptId || localStorage.getItem("lastAttemptId");

    if (!attemptId) {
      console.error("Не найден идентификатор попытки для печати");
      return;
    }

    const protocolMode = localStorage.getItem("protocolMode") || "dynamic";
    const protocolUrl =
      protocolMode === "template"
        ? "/api/test-protocol-template/pdf"
        : `/test-protocol/${attemptId}?print=1`;

    const printWindow = window.open(protocolUrl, "_blank");

    if (printWindow) {
      printWindow.focus();
    } else {
      console.error("Не удалось открыть окно для печати");
    }
  };

  return (
    <div role="main">
      <div className="title"></div>
      <div className="title22">
        <div>Тестирование - 1 -й этап</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="course-breadcrumb">
        Мои курсы › Тестирование - 1-й этап{" "}
        {formatCourseDate(localStorage.getItem("startTime"))}
      </div>
      <div className="container">
        <div className="content">
          <div
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
            className="gohome"
          >
            Выход
          </div>
          <h2>Тестирование</h2>
          <div className="box quizinfo">
            <p>Ограничение по времени: 1 ч.</p>
            <p>Метод оценивания: Последняя попытка</p>
          </div>
          <h3>Результаты ваших предыдущих попыток</h3>
          <table className="generaltable quizattemptsummary">
            <thead>
              <tr>
                <th className="header c0" style={{ textAlign: "center" }} scope="col">
                  Попытка
                </th>
                <th className="header c1" style={{ textAlign: "left" }} scope="col">
                  Состояние
                </th>
                <th className="header c2 lastcol" style={{ textAlign: "center" }} scope="col">
                  Просмотр
                </th>
              </tr>
            </thead>
            <tbody>
              {attempts.map((attempt, index) => (
                <tr key={index} className={index === attempts.length - 1 ? "lastrow" : ""}>
                  <td className="cell c0" style={{ textAlign: "center" }}>
                    {attempt.id}
                  </td>
                  <td className="cell c1" style={{ textAlign: "left" }}>
                    {attempt.status}
                    <span className="statedetails">
                      Отправлено {attempt.submittedAt}
                    </span>
                  </td>
                  <td className="cell c2 lastcol" style={{ textAlign: "center" }}>
                    <div
                      style={{ color: "#009688", cursor: "pointer" }}
                      onClick={() => navigate("/test-review")}
                    >
                      Просмотр
                    </div>
                    <div className="button-print" onClick={handlePrint}>
                      Напечатать
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="box quizattempt">
            <p>
              Вы должны подождать, прежде чем сможете повторить попытку
              прохождения теста. Скоро Вам будет разрешено начать еще одну
              попытку.
            </p>
          </div>
        </div>
        <FakeNavigation />
      </div>
    </div>
  );
};

export default TestResultsPage;
